// import { clearDataAction, logoutAction } from './reducers';
import api from '../../api';
import { AuthService } from '../api';
import { unauthorizedApiResponseInterceptor } from '../api/interceptor';
import { UserType } from '../api/models';

const initialize = (store: any, setToken: (token?: string) => void) => {
  const state = store.getState();
  unauthorizedApiResponseInterceptor(() => {
    // store.dispatch(logoutAction);
    // store.dispatch(clearDataAction());
    api.setUserToken(undefined);
    api.setSalespersonToken(undefined);
    api.setUserType(undefined);
    // window.location.reload();
  }, [AuthService.loginUrl]);

  // setToken(state.authUser.token);
  api.setBrandID(state.brandAndBranch?.selectedBrand?.brandID);
  api.setBranchID(state.brandAndBranch?.selectedBranch?.warehouseID);
  if (state.authUser.userToken) {
    api.setUserToken(state.authUser.userToken);
    // store.dispatch(userActions.fetchProfile());
  }
  if (state.authUser.salesPersonToken) {
    api.setSalespersonToken(state.authUser.salesPersonToken);
  }
  if (state.authUser.userType) {
    api.setUserType(state.authUser.userType);
  }
};

export default initialize;
